let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');
// Import Greensock and it's plugins.
let CSSPlugin = require('../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');
let EasePack = require('../../node_modules/gsap/src/uncompressed/easing/EasePack');
let TweenLite = require('../../node_modules/gsap/src/uncompressed/TweenLite');

let MegaMenu = require('./megamenu');
let ContentNav = require('./content-nav');

let helpers = require("../utilities/helpers");

class MainNav {

  constructor(context) {
    this.$body = $('body');

    if (context !== document) {
      return false;
    }
    this.$topbar = $('.js-topbar');
    this.$nav = $('.js-main-nav');
    this.$wrapper = $('.js-main-nav-wrapper');
    this.$content = $('.js-main-nav-content');
    this.$contentNav = $('#js-content-nav');
    this.contentNav; // Where we will store the naviator.
    this.$contentNavToggle = $('.js-content-nav-toggle');
    this.$viewToggle = $('.js-main-nav-toggle');
    this.$closeMobileNavBtn = $('.js-mobile-nav-close');
    this.$searchToggleBtn = $('.js-main-nav-search-toggle');
    this.$searchContent = $('.js-main-nav-search');
    this.$mainNavSearchField = $('#main-nav-search');
    this.isChangingView = false;
    this.scrollTimer = null;
    this.prevScrollTop = 0;

    this.megaMenu = new MegaMenu();

    // On a lab group page, the nav starts in the collapsed state.
    this.isLabGroup = $('.path-group').length > 0;

    /*
      To explicitly hide the navigator region, you can add the path to the block.
      /admin/structure/block/manage/navigatorblock
    */
    if (this.$contentNav.length) {
      this.contentNav = new ContentNav();

      if (this.contentNav.hasContent) {
        this.contentNav.buildContentNav();
        this.$contentNavToggle.removeClass('hide');
        // Open content nav by default for RMD instrument pages.
        if (this.contentNav.$body
          .hasClass('node--type-rehabilitation-measure-instrumen')) {
            this.handleContentToggleClick();
        }
      }
    }

    // left: 37, up: 38, right: 39, down: 40,
    // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
    this.keys = {37: 1, 38: 1, 39: 1, 40: 1};

    this.bindEvents();
    this.setSearchPlaceholder();
  }

  bindEvents() {
    // Bind clicks to content nav button - hamburger to the left of logo in nav.
    if (this.$contentNav.length && this.contentNav.hasContent) {
      this.$contentNavToggle.on('click.navContent', () => this.handleContentToggleClick());
    }

    // Bind clicks to 'menu' button - toggles visibility of nav links.
    this.$viewToggle.on('click.navView', () => this.handleViwToggleClick());

    // Bind clicks to search toggle.
    this.$searchToggleBtn.on('click.navSearch', () => this.handleSearchClick());

    // MegaMenu events.
    if (breakpoints.current === 'large' || breakpoints.current === 'xlarge') {
      this.bindMegaMenuEvents();
    }

    $(window).off('scroll.nav').on('scroll.nav', () => this.watchScroll());

    // On Android devices this breaks the keyboard for text inputs.
    // So, we handle it slighlty differently.
    // We also close the mobile nav if it's open.
    if (helpers.isAndroid()) {
      window.addEventListener("orientationchange", () => {
        this.resizeNav();

        if (this.$nav.hasClass('mobile-open')) {
          this.$nav.toggleClass('mobile-open');
          this.enableScroll();
          this.$closeMobileNavBtn.off('click');
        }
      }, false);
    }
    else {
      $(window).resize(() => this.resizeNav()).trigger('resize');
    }

  }

  bindMegaMenuEvents() {
    this.megaMenu.$megaMenuCloseBtns.off('click.megmenuClose').on('click.megmenuClose', (e) => {
      e.preventDefault();
      this.megaMenu.closeMegaMenu(e)
    });
    this.megaMenu.$megaMenuToggles.off('click.megamenu').on('click.megamenu', (e) => {
      e.preventDefault();
      this.megaMenu.handleNavClick(e);

      if (this.$contentNav.length && this.contentNav.hasContent) {
        this.contentNav.close();
      }
    });
  }

  unBindMegaMenuEvents() {
    this.megaMenu.$megaMenuToggles.off('click.megamenu');
  }

  resizeNav() {
    // Close the navigator.
    if (this.$contentNav.length && this.contentNav.hasContent) {
      this.contentNav.close();
    }

    if (breakpoints.current === 'large' || breakpoints.current === 'xlarge') {

      this.enableScroll();

      this.bindMegaMenuEvents();
    }
    else {
        this.unBindMegaMenuEvents();
    }

    this.setSearchPlaceholder();
  }

  watchScroll() {
    // clear any previous pending timer
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
    this.scrollTimer = setTimeout(() => {
      if (
        breakpoints.current === 'large' ||
        breakpoints.current === 'xlarge'
      ) {
        this.handleScroll();
      }
      else {
        this.handleMobileScroll();
      }
    }, 10);
  }

  handleScroll() {
    var currentScrollPos = $(document).scrollTop() <= 0 ? 0 : $(document).scrollTop();
    var direction = null;

    if (currentScrollPos > this.prevScrollTop) {
      direction = 'down';
    }
    else if (currentScrollPos < this.prevScrollTop) {
      direction = 'up';
    }

    if (direction === 'down' && currentScrollPos > 130) {
      this.$wrapper.addClass('off-screen');

      if (!this.isChangingView && !this.$wrapper.hasClass('collapsed')) {
        this.toggleNavView();
        this.megaMenu.closeMegaMenu();
      }

      // If search is open, close it.
      if (this.$searchContent.hasClass('open')) {
        this.closeSearch();
      }
    }
    else if (direction === 'up'){

      if (currentScrollPos <= 130 && this.$wrapper.hasClass('collapsed') && !this.isLabGroup) {
        this.toggleNavView();
      }
      this.$wrapper.removeClass('off-screen');
    }

    this.prevScrollTop = $(document).scrollTop() <= 0 ? 0 : $(document).scrollTop();
  }

  handleMobileScroll() {
    var currentScrollPos = $(document).scrollTop() <= 0 ? 0 : $(document).scrollTop();
    var direction = null;

    if (this.$body.hasClass("noscroll")) {
      return false;
    }

    if (currentScrollPos > this.prevScrollTop) {
      direction = 'down';
    }
    else if (currentScrollPos < this.prevScrollTop) {
      direction = 'up';
    }

    if (this.$nav.hasClass('mobile-open')) {
      return false;
    }

    if (direction === 'down') {
      this.$wrapper.addClass('off-screen');
    }
    else if (direction === 'up'){
      this.$wrapper.removeClass('off-screen');
    }

    this.prevScrollTop = $(document).scrollTop() <= 0 ? 0 : $(document).scrollTop();
  }

  handleContentToggleClick() {
    // Close megamenu.
    this.megaMenu.closeMegaMenu();

    // Close search if it's open.
    if (this.$searchContent.hasClass('open')) {
      this.closeSearch();
    }

    if (this.$contentNav.length && this.contentNav.hasContent) {

      if (!this.contentNav.$nav.hasClass('open')) {
        this.contentNav.open();
      }
      else {
        this.contentNav.close();
      }
    }

    return false;
  }

  handleViwToggleClick() {

    if (
      breakpoints.current === 'large' ||
      breakpoints.current === 'xlarge'
    ) {
      this.toggleNavView();
    }
    else {
      this.toggleNavViewMobile();
    }

    return false;
  }

  toggleNavViewMobile() {
    var $labNav = this.$wrapper.find('.js-lab-nav');
    this.$nav.toggleClass('mobile-open');

    // Check if we have a lab nav and if it is open.
    // If we do -- close it.
    if ($labNav.length > 0 && $labNav.hasClass("menu-collapsible__open")) {
      $labNav.removeClass("menu-collapsible__open");
    }

    if (this.$nav.hasClass('mobile-open')) {
      this.disableScroll();
      // Bind this event to the close button.
      this.$closeMobileNavBtn.on('click', () => this.toggleNavViewMobile());
    }
    else {
      this.enableScroll();
      this.$closeMobileNavBtn.off('click');
    }
  }

  toggleNavView() {

    window.TweenLite.to(this.$content, 0.25, {
      opacity: 0,
      onStart: () => {
        this.isChangingView = true;
      },
      onComplete: () => {
        this.$wrapper.toggleClass('collapsed');
        // If we are on a lab group page we change the spacing at top.
        if (this.isLabGroup) {
          this.$topbar.toggleClass('full-sized');
        }
      }
    });

    window.TweenLite.to(this.$content, 0.25, {
      opacity: 1,
      delay: 0.5,
      onComplete: () => {
        this.isChangingView = false;
      }
    });
  }

  handleSearchClick() {

    this.megaMenu.closeMegaMenu();

    if (!this.$searchContent.hasClass('open')) {
      this.openSearch();
    }
    else {
      this.closeSearch();
    }

    return false;
  }

  openSearch() {
    this.$searchContent.addClass('open');
    this.$searchToggleBtn.addClass('open');
    this.$searchToggleBtn.find('.main-nav__search-toggle__text').html('close');
    this.setSearchFocus();
  }

  closeSearch() {
    this.$searchContent.removeClass('open');
    this.$searchToggleBtn.removeClass('open');
    this.$searchToggleBtn.find('.main-nav__search-toggle__text').html('search');
    this.$nav.off('keydown.navSearch');
  }

  setSearchFocus() {
    // Set focus to search field.
    this.$searchContent.find('#main-nav-search').focus();

    this.$nav.on('keydown.navSearch', (e) => this.updateSearchFocus(e));
  }

  updateSearchFocus(e) {

    // jQuery formatted selector to search for focusable items
    var focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";

    var focusedItem;
    var numberOfFocusableItems;
    var focusedItemIndex;
    // esc key press.
    if (e.keyCode === 27) {
      this.$searchToggleBtn.focus();
    }
    else if (e.keyCode === 9) {
      var children = this.$searchContent.find('*')
      var focusableItems = children.filter(focusableElementsString).filter(':visible').add('.js-main-nav-search-toggle');

      focusedItem = $(document.activeElement);
      // get the number of focusable items
      numberOfFocusableItems = focusableItems.length

      focusedItemIndex = focusableItems.index(focusedItem);

      if (!e.shiftKey && (focusedItemIndex == numberOfFocusableItems - 1)) {
        focusableItems.get(0).focus();
        e.preventDefault();
      }
      else if (e.shiftKey && focusedItemIndex == 0) {
        focusableItems.get(numberOfFocusableItems - 1).focus();
        e.preventDefault();
      }
    }
  }

  setSearchPlaceholder() {
    if (breakpoints.current === "large" || breakpoints.current === "xlarge") {
      this.$mainNavSearchField.attr("placeholder", "People, places, conditions, resources...")
    }
    else {
      this.$mainNavSearchField.attr("placeholder", "Search");
    }
  }

  disableScroll() {
    this.$body.addClass('noscroll');
  }

  enableScroll() {
    this.$body.removeClass('noscroll');
  }
}

module.exports = {
  attach: function(context, settings) {
    let mainNav = new MainNav(context);
  }
};
